import { useState } from 'react';

import { SR_API_ACTION_ADDRESS_REGISTER_ADDRESS_STRING } from 'api/utilityActionTypes';
import { pickAutocompleteFields } from 'server/models/Address/fieldgroups';
import requestUtilityApi from 'client/actions/requestUtilityApi';
import { showFieldIf } from 'client/helpers/formikHelpers';

const useAddressRegisterAutocomplete = ({
  dispatch,
  afterSubmit,
  utilityPartnerId,
  onRegisterSuccess,
}) => {
  const [submitErrorMessage, setSubmitErrorMessage] = useState(null);

  const onSubmit = (formValues, formikBag) => {
    const { utilityPartnerId: formUtilityPartnerId, addressString } = formValues;
    setSubmitErrorMessage(null);

    dispatch(requestUtilityApi, {
      action: SR_API_ACTION_ADDRESS_REGISTER_ADDRESS_STRING,
      payload: {
        utilityPartnerId: parseInt(formUtilityPartnerId, 10),
        addressString,
      },
      onSuccess(address) {
        formikBag.resetForm();

        if (afterSubmit) {
          afterSubmit(address);
        }

        if (onRegisterSuccess) {
          onRegisterSuccess(address);
        } else if (!utilityPartnerId) {
          global.alert('Address registered successfully.');
        }
      },
      onError(error) {
        setSubmitErrorMessage(error?.message);
      },
    });
  };

  return {
    onSubmit,
    submitErrorMessage,
  };
};

const getAutocompleteAddressFieldsValid = (formValues) => {
  const autocompleteAddressFields = pickAutocompleteFields(formValues);
  return Object.keys(autocompleteAddressFields)
    .filter((fieldId) => fieldId !== 'county')
    .every((fieldId) => autocompleteAddressFields[fieldId]);
};

const getAutocompleteAddressFields = ({ formValues, onManualEntry }) => {
  return [
    showFieldIf(formValues?.utilityPartnerId, {
      id: 'addressString',
      title: 'Address',
      type: 'smarty_address_autocomplete',
      properties: {
        onManualEntry,
        placeholder: 'Search for address',
      },
    }),
  ];
};

const getAutocompleteFieldGroups = ({ utilityPartnerField, autocompleteField } = {}) => {
  return {
    fieldGroups: [
      ...(utilityPartnerField
        ? [{ fields: [utilityPartnerField], layoutClassName: 'defaultRow' }]
        : []),
      ...(autocompleteField
        ? [{ fields: [autocompleteField], layoutClassName: 'defaultRow' }]
        : []),
    ],
  };
};

export {
  getAutocompleteAddressFieldsValid,
  getAutocompleteAddressFields,
  getAutocompleteFieldGroups,
};
export default useAddressRegisterAutocomplete;
